<template>

    <v-stepper :model-value="current_step" non-linear alt-labels elevation="0" style="width: 100%;">
        <v-stepper-header class="d-flex justify-center align-center" style="width: 100%;">

            <v-stepper-item title="Parcours" :complete="isComplete(1)" value="1" @click="goToStep('1')"
                :icon="getIcon(1)" :color="getColor(1)" :editable="isParcoursOpenable"
                :class="{ 'v-stepper-item--locked': isLocked(1) }" class="font-weight-bold"></v-stepper-item>

            <v-divider :color="getColor(1)" class="border-opacity-100"></v-divider>

            <v-stepper-item title="Identité" :complete="isComplete(2)" value="2" @click="goToStep('2')"
                :icon="getIcon(2)" :color="getColor(2)" :editable="isIdentityOpenable"
                :class="{ 'v-stepper-item--locked': isLocked(2) }" class="font-weight-bold"></v-stepper-item>

            <v-divider :color="getColor(2)" class="border-opacity-100"></v-divider>

            <v-stepper-item title="Options" :complete="isComplete(3)" value="3" @click="goToStep('3')"
                :icon="getIcon(3)" :color="getColor(3)" :editable="isOptionsOpenable"
                :class="{ 'v-stepper-item--locked': isLocked(3) }" class="font-weight-bold"></v-stepper-item>
        </v-stepper-header>
    </v-stepper>
</template>

<script>
import { useBookingStore } from '@/stores/bookingStore';
import { mapStores } from 'pinia';
export default {
    props: {
        current_step: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapStores(useBookingStore),
        anotherInscriptionNotFinished() {
            for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
                if (!this.bookingStore.inscriptions[i].finished && this.index != i) {
                    return true;
                }
            }
            return false;
        },


        isParcoursOpenable() {
            if (this.anotherInscriptionNotFinished) {
                return false;
            }
            return parseInt(this.current_step) > 1;
        },
        isIdentityOpenable() {
            if (this.anotherInscriptionNotFinished) {
                return false;
            }
            return parseInt(this.current_step) > 2;
        },
        isOptionsOpenable() {
            if (this.anotherInscriptionNotFinished) {
                return false;
            }
            return parseInt(this.current_step) > 3;
        }
    },
    methods: {
        goToStep(step) {
            this.$emit('goToStep', step);
        },
        isComplete(step) {
            return parseInt(this.current_step) > step;
        },
        isLocked(step) {
            return parseInt(this.current_step) < step;
        },
        isCurrent(step) {
            return parseInt(this.current_step) === step;
        },

        getIcon(step) {
            if (this.isComplete(step)) {
                return 'mdi-check';
            }
            if (this.isLocked(step)) {
                return 'mdi-lock';
            }
            if (this.isCurrent(step)) {
                return 'mdi-pencil';
            }
            return '';
        },
        getColor(step) {
            if (this.isComplete(step)) {
                return 'green-darken-4';
            }
            else if (this.isCurrent(step)) {
                return 'primary-dark';
            }
            else if (this.isLocked(step)) {
                return 'grey';
            }
            return '';
        },

    }

}
</script>

<style lang="scss">
.v-stepper--alt-labels .v-stepper-header .v-divider {
    align-self: auto !important;
}

.v-stepper {
    box-shadow: none !important;
    border-bottom: 1px solid rgb(221, 221, 221) !important;
}

.v-stepper-item {
    cursor: pointer;
    padding: .5rem;
}

.v-stepper--alt-labels .v-stepper-item__avatar.v-avatar {
    margin-bottom: .5rem !important;
}

.v-stepper-item--locked {
    .v-stepper-item__avatar.v-avatar {
        background-color: rgb(var(--v-theme-darkgrey)) !important;
        color: rgb(var(--v-theme-white)) !important;
    }

    .v-stepper-item-title {
        color: rgb(var(--v-theme-darkgrey)) !important;
    }
}
</style>